import { Component, Input, OnInit } from '@angular/core';
import { tap } from 'rxjs/operators';

import {
    takeUntilDestroy,
    TakeUntilDestroy,
} from '../../../common/take-until-destroy.decorator';
import { PeriodType } from '../../../widget/date-range.widget.model';
import { UpViewProfile } from '../core/model/up-view-profile.model';
import { UserProfileService } from '../core/user-profile.service';

import { TranslationKeyMap } from './tooltip.component.i18n';

@Component({
    selector: 'cmps-coaching-user-profile-tooltip',
    templateUrl: './tooltip.component.html',
    host: {
        class: 'cmps-coaching-user-profile-tooltip',
    },
})
@TakeUntilDestroy()
export class TooltipComponent implements OnInit {
    @Input() userId: number;
    @Input() periodTypeId: number;

    /** @private */
    readonly _i18n = TranslationKeyMap;

    /** @private */
    _hasPendingData: boolean;

    /** @private */
    _userProfile: UpViewProfile;

    constructor(private readonly _service: UserProfileService) {
        this.periodTypeId = PeriodType.ROLLING_30;
    }

    ngOnInit(): void {
        this._load();
    }

    private _load(): void {
        this._hasPendingData = true;
        this._service
            .retrieve(this.userId, this.periodTypeId)
            .pipe(
                tap((ret) => {
                    this._userProfile = ret;
                    this._hasPendingData = false;
                }),
                takeUntilDestroy(this),
            )
            .subscribe();
    }
}
